import { SimpleGrid, Skeleton } from "@mantine/core";

const SkeletonFeatures = () => {
  return (
    <SimpleGrid className="box-features" cols={{ base: 1, sm: 3 }}>
      <Skeleton h={520} w={266} />
      <Skeleton h={520} w={266} />
      <Skeleton h={520} w={266} />
    </SimpleGrid>
  );
};
export default SkeletonFeatures;
